module.exports = __webpack_public_path__ + "static/media/upload-folder-icon.1c624f18.svg";